import { render, staticRenderFns } from "./PageSizeSelectList.vue?vue&type=template&id=33a8298c&scoped=true"
import script from "./PageSizeSelectList.vue?vue&type=script&lang=ts"
export * from "./PageSizeSelectList.vue?vue&type=script&lang=ts"
import style0 from "./PageSizeSelectList.vue?vue&type=style&index=0&id=33a8298c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a8298c",
  null
  
)

export default component.exports